var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9624 0C24.8284 0 27.9624 3.13401 27.9624 7L27.9624 29.8312L30.4743 27.2923C33.1933 24.544 37.6016 24.544 40.3206 27.2923C43.0396 30.0405 43.0396 34.4964 40.3206 37.2447L26.8856 50.8244C25.3267 52.4001 23.2126 53.0724 21.1799 52.8413C19.1472 53.0724 17.0331 52.4001 15.4743 50.8244L2.03924 37.2447C-0.679746 34.4964 -0.679746 30.0405 2.03924 27.2923C4.75822 24.544 9.16656 24.544 11.8855 27.2923L13.9624 29.3915L13.9624 7C13.9624 3.13401 17.0964 0 20.9624 0Z",
    fill: "url(#arrow_card_gradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow_card_gradient",
    x1: 21.1799,
    y1: -1.00859,
    x2: 21.1799,
    y2: 52.8857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF8E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCard);
export default __webpack_public_path__ + "static/media/arrow-card.32e0fed2d5dde58f1359b5778b455e6b.svg";
export { ForwardRef as ReactComponent };